import { render, staticRenderFns } from "./IssuedPassesList.vue?vue&type=template&id=1e0b1ad0"
import script from "./IssuedPassesList.vue?vue&type=script&lang=js"
export * from "./IssuedPassesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports